class ResizeHelper {
  
  private static instance: ResizeHelper;
  
  private callbacks: Array<() => void> = [];
  
  private RESIZE_THROTTLE_TIMEOUT = 150;
  
  private resizeTimeout!: number;
  
  constructor() {
    this.subscribe();
  }
  
  subscribe(): void {
    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = window.setTimeout(() => {
        this.callbacks.forEach((c) => {
          c();
        });
      }, this.RESIZE_THROTTLE_TIMEOUT);
    });
  }
  
  addCallback(c: () => void): void {
    this.callbacks.push(c);
  }
  
  public static get Instance(): ResizeHelper {
    if (!this.instance) this.instance = new this();
    return this.instance;
  }
}

export default ResizeHelper;
